<app-title-bar titleText="i18n.base.changePassword.header"></app-title-bar>
<div class="row">
  <div class="col-lg-4 offset-lg-4 col-md-6 offset-md-3">
    <form [formGroup]="changePasswordForm"> <!-- (ngSubmit)="changePassword()"-->
      <div class="form-group">
        <label for="oldPassword" class="required">{{ "i18n.base.changePassword.oldPassword" | translate }}</label>
        <input id="oldPassword"
               type="password"
               class="form-control"
               formControlName="oldPassword"
               appPasswordVisibility>
        <!--  placeholder="{{ 'i18n.base.changePassword.requirement' | translate }}" -->
        <app-error-messages [control]="oldPasswordControl"></app-error-messages>
      </div>
      <div class="form-group">
        <label for="newPassword" class="required">{{ "i18n.base.changePassword.newPassword" | translate }}</label>
        <input id="newPassword"
               type="password"
               class="form-control"
               formControlName="newPassword"
               appPasswordVisibility>
        <app-error-messages [control]="newPasswordControl"></app-error-messages>
      </div>
      <div class="form-group">
        <label for="newPasswordConfirm" class="required">{{ "i18n.base.changePassword.newPasswordConfirm" | translate }}</label>
        <input id="newPasswordConfirm"
               type="password"
               class="form-control"
               formControlName="newPasswordConfirm"
               appPasswordVisibility>
        <app-error-messages [control]="newPasswordConfirmControl"></app-error-messages>
      </div>
      @if (changePasswordForm.errors?.passwordConfirmationMismatch) {
        <div class="text-danger mb-2">
          {{'i18n.core.messages.changePassword.pwdDoNotMatch' | translate}}
        </div>
      }
      <div class="d-flex">
        <div class="flex-grow-1"></div>
        <button type="submit"
                class="btn btn-primary ms-auto"
                (click)="changePassword()"
                [disabled]="!changePasswordForm.valid">
          @if (loading) {
            <div class="spinner-border spinner-border-sm me-3"
               role="status"></div>
          }
          {{ "i18n.base.changePassword.changePassword" | translate }}
        </button>
      </div>
    </form>
  </div>
</div>
